// = Libs =
import React, { FC } from 'react';
import clsx from 'clsx';

// = Styles =
import classes from './icon-button.module.scss';

// = Types =
import { IconButtonProps } from './icon-button.types';

// = Components =
import Icon from '@/common/components/ui/icon/icon';

const IconButton: FC<IconButtonProps> = (props) => {
  const {
    type = 'button',
    iconType = 'file',
    color = 'primary',
    disabled = false,
    onClick,
    addClass,
  } = props;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onClick && !disabled && onClick(e);
  };

  return (
    <button
      type={type}
      className={clsx({
        [classes['button']]: true,
        [addClass || '']: !!addClass,
        [classes[`button--${color}`]]: color,
        [classes['button-disabled']]: disabled,
      })}
      onClick={handleClick}>
      <Icon type={iconType} color="light" />
    </button>
  );
};

export default IconButton;
